import { render, staticRenderFns } from "./OfferTrafficStatus.vue?vue&type=template&id=4571fe9a"
import script from "./OfferTrafficStatus.vue?vue&type=script&lang=js"
export * from "./OfferTrafficStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports